module.exports = __webpack_public_path__ + "img/smh.2edf78d8.png";